/**
 *
 * Version Header
 *
 */

import React from 'react';
import version from 'version';
import EnvironmentBanner from '../EnvironmentBanner';

function AppHeader() {
  return (
    <div>
      <EnvironmentBanner />
      <nav className="navbar sticky-top navbar-dark bg-dark py-2 text-warning text-uppercase">
        TAXI - {version}
      </nav>
    </div>
  );
}

export default AppHeader;
